import i18n from '../i18n';
import type { OnboardingTourContext } from './onboardingTourContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const tt = (key: string, opts?: Record<string, unknown>) => (i18n as any).t(key, opts);
const t = (key: string, opts?: Record<string, unknown>) => tt(`onboarding:${key}`, opts);

export function getParentTour(ctx: OnboardingTourContext) {
  const steps = [
    {
      target: '[data-onboarding="dashboard-main"]',
      title: t('parentTourDashboardTitle'),
      content: t('parentTourDashboardContent'),
      placement: 'bottom' as const,
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-schedule"]',
      title: tt('nav:schedule'),
      content: t('parentTourScheduleContent'),
      placement: 'right' as const,
      skipBeacon: true
    }
  ];

  if (ctx.hasLinkedSchool) {
    steps.push({
      target: '[data-onboarding="nav-balance"]',
      title: tt('nav:myBalance'),
      content: t('parentTourBalanceContent'),
      placement: 'right' as const,
      skipBeacon: true
    });
  } else {
    steps.push({
      target: '[data-onboarding="nav-apply"]',
      title: t('tourApplyTitle'),
      content: t('tourApplyContent'),
      placement: 'right' as const,
      skipBeacon: true
    });
  }

  return steps;
}

export function getParentWelcome() {
  return {
    subtitle: t('welcomeParentSubtitle'),
    startLabel: t('welcomeStartTour')
  };
}

export function getParentChecklistUi() {
  return {
    title: t('checklistParentTitle'),
    doneTitle: t('checklistParentDone'),
    doneMessage: t('parentChecklistDoneMessage'),
    doneButton: t('parentChecklistDoneButton'),
    doneRoute: '/schedule'
  };
}
